import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  implements OnInit, OnDestroy{
  
  private subscription!: Subscription;
  constructor() {
   
  }
    ngOnInit(): void {
    this.subscription = interval(10 * 60 * 1000).subscribe(() => {
      this.myFunction();
    });
  }
  myFunction() {  
    console.log('Called every 10 minutes');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
}



